import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Agile(props) {
  return (
    <div className="tekrevol_gray_bg p-100">
      <Container classNanme="h-100">
        <Row classNanme="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <div className="example" data-text="Tech Leaders">
              <h2>Benefits of Choosing Serverless Computing</h2>
            </div>
            <p>
              Being a top provider of serverless computing services, we take
              great satisfaction in offering our customers a variety of
              advantages. With the help of our serverless solutions, businesses
              can get rid of the challenges associated with infrastructure
              maintenance and concentrate entirely on application development
              and innovation.
            </p>
            <p>
              Businesses may speed up innovation, scale operations with ease,
              and realize significant cost savings by implementing serverless
              computing, which will help them succeed in the current digital
              economy.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="agile_title my-auto offset-xl-1"
          >
            <div className="content_pointer">
              <div className="pointers_item">
                <div className="title_count">
                  56+<span>Projects Completed</span>
                </div>
              </div>
              <div className="pointers_item">
                <div className="title_count">
                  23+<span>Businesses Served</span>
                </div>
              </div>
              <div className="pointers_item">
                <div className="title_count">
                  08+<span>Industries Served</span>
                </div>
              </div>
            </div>
            <StaticImage
              src="../../images/services/servless-computing/benefits.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Agile;
